import React from "react";
import Header from "../../../components/user/Header";
import Details from "../../../components/user/posts/Details";
import BeritaPopuler from "../../../components/user/posts/BeritaPopuler";
import Footer from "../../../components/user/Footer";

function DetailsPosts() {
	return (
		<>
			<Header />

			{/* Spacer for fixed header */}
			<div className="h-16" />

			{/* Content */}
			<div className="max-w-8xl mx-auto px-4 py-8">
				<div className="flex flex-col lg:flex-row gap-8">
					{/* Main Content */}
					<div className="w-full lg:w-[65%]">
						<Details />
					</div>

					{/* Sidebar */}
					<div className="w-full lg:w-[35%]">
						<BeritaPopuler />
					</div>
				</div>
			</div>

			<Footer />
		</>
	);
}

export default DetailsPosts;
